import { AccountType, Params } from '@packages/authentication/interfaces/LoginParams'
import { InitOptions } from '@packages/authentication'

const applyUrl = '/web/rest/3rd/apply'
// /web/rest/3rd/login/{token}
const loginUrl = '/web/rest/3rd/login/'

export enum ThirdPartyType {
  // 微信
  wx = 41,
  // 微信公众号
  wxPublic = 42,
  // 微信小程序
  wxMiniProgram = 43,
  // qq
  qq = 21,
  // 微博
  weibo = 31
}

export enum ConnectIdType {
  unionId = '1',
  openId = '2'
}

export class ApplyParams extends Params {
  resultUrl: string
  thirdPartyType: ThirdPartyType
  connectIdType: ConnectIdType
}

interface ThirdPartyOptions extends InitOptions {
  thirdAuthUrl?: string
}

class ThirdParty {
  options: ThirdPartyOptions
  wxloginTokenKey = 'wxloginToken'

  constructor(options: ThirdPartyOptions) {
    this.options = options
  }

  async apply(resultUrl: string, open: boolean) {
    const params = new ApplyParams()
    params.thirdPartyType = ThirdPartyType.wx
    params.accountType = AccountType.customer
    params.connectIdType = ConnectIdType.openId
    params.resultUrl = resultUrl
    params.service = this.options.service
    const loginWindow = this.open('about:blank')
    const { data } = await this.options.request.post(`${this.options.thirdAuthUrl}${applyUrl}`, params)
    if (open && loginWindow) {
      loginWindow.location.href = data.data.authUrl
    }
    return data.data.authUrl
  }

  async weixinApply(resultUrl: string) {
    const params = new ApplyParams()
    params.thirdPartyType = ThirdPartyType.wx
    params.accountType = AccountType.customer
    params.connectIdType = ConnectIdType.openId
    params.resultUrl = resultUrl
    params.service = this.options.service
    const { data } = await this.options.request.post(`${this.options.thirdAuthUrl}${applyUrl}`, params)
    return data.data.authUrl
  }

  async login(token: string) {
    const { data } = await this.options.request.get(`${this.options.thirdAuthUrl}${loginUrl}${token}`)
    return data.data
  }

  open(url: string) {
    return window.open(
      url,
      'newName',
      'height=600, width=600, top=200, left=200, menubar=no, scrollbars=no, resizable=no, location=no, status=no'
    )
  }

  setWxloginToken(value: string) {
    localStorage.setItem(`${this.options.prefix}.${this.wxloginTokenKey}`, value)
  }

  getWxloginToken() {
    return localStorage.getItem(`${this.options.prefix}.${this.wxloginTokenKey}`)
  }
}

export default ThirdParty
